import React from "react";
import { Typography } from "antd";
import moment from "moment";
const { Text } = Typography;

const DayOfWeek = (props) => {
  const { text } = props;
  return <Text>{moment.weekdays(true)[text]}</Text>;
};

export default DayOfWeek;
